<template>
  <div
    class="cookie-policy container"
    data-test="popup-cookiepolicy">
    <h2>Cookie Policy</h2>
    <p>
      We and our trusted partners use technologies such as cookies and mobile ad identifiers to collect and process personal data to understand our users, improve our advertising, and analyze user interactions with us, on our website and through our ads and content. By continuing to use our service you agree to our and our partners’ processing of personal data for these purposes as described in our
      <router-link
        to="privacy"
        color="primary"
        target="_blank"
      >
        Privacy Policy
      </router-link> and our Partners’ Privacy Policies.
      <a
        color="primary"
        @click="manageConsents"
      >
        Manage your consents here.
      </a>
    </p>
    <el-button
      type="primary"
      data-test="btn-accept"
      @click="acceptCookiePolicy"
    >
      Accept
    </el-button>
  </div>
</template>

<script>
// import euCountries from '../assets/json/eu_countries.json';

export default {
  data() {
    return {
      // euCountries,
    };
  },
  // computed: {
  //   inEU() {
  //     const { country } = this.$store.getters;

  //     if (country) {
  //       return euCountries.find(euCountry => euCountry.code === country.toUpperCase());
  //     }

  //     return false;
  //   },
  // },
  methods: {
    acceptCookiePolicy() {
      this.$store.dispatch('acceptCookiePolicy');
    },
    manageConsents() {
      this.$store.dispatch('acceptCookiePolicy');

      // eslint-disable-next-line no-undef
      consentManager.openConsentManager();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

.cookie-policy {
  padding: 35px 60px;
  border-radius: 5px 5px 0 0;

  background-color: white;

  z-index: 10000;

  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  border: 1px solid $light-gray2;
  border-bottom: none;

  h2 {
    font-size: 20px;
    color: $black;
    margin: 0;
    line-height: normal;
  }

  p {
    margin: 16px 0 35px;

    a {
      cursor: pointer;
    }
  }

  button {
    padding: 11px 20px;
    min-width: 102px;
  }

  &.slide-up-enter,
  &.slide-up-leave-to {
    transform: translateY(calc(100%)) translateX(-50%);
  }

  &.slide-up-enter-active, &.slide-up-leave-active {
    transition: 300ms;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/CookiePolicy.vue